import { WallpaperDataType } from 'shared/types/index'

export interface WallpaperItemProps {
  wallpaper: WallpaperDataType
  isSelected: boolean
  onClick: () => void
  selectedText: string
  isCustom?: boolean
}
